window.PlummeI18n.register('no', {
  'bank.group.toast.booked': 'Matchinggruppen er bokført samlet.',
  'bank.group.err.bookUnavailable': 'Matchinggruppen ble godkjent, men bokføring er ikke tilgjengelig.',
  'bank.group.err.bookFailed': 'Kunne ikke bokføre matchinggruppen.',
  'bank.group.book': 'Bokfør gruppe',
  'bank.resolve.reversePaymentInfo': 'Reversering opphever betalingen med spor, gjenåpner leverandørfakturaen og åpner banklinjen for ny kontroll.',
  'err.bankMatchReversalReason': 'Oppgi en årsak til at bankkoblingen reverseres.',
});
